<template>
	<v-container fluid>
		<v-container>
			<v-card>
                <v-card-title>{{ $t('terms.title') }}</v-card-title>
                <v-card-subtitle>{{ $t('terms.subtitle') }}</v-card-subtitle>
                <v-card-text class="kktin" v-html="terms_html.content">
                </v-card-text>
            </v-card>
		</v-container>
	</v-container>
</template>

<script>
import ApiService from "@/services/api_service";

export default {
  name: 'Terms',
  data() {
    return {
      terms_html: {},
    }
  },
  mounted() {
    ApiService.get(`/terms`).then((response) => {
      this.terms_html = response.data;
    }).catch(() => {});
  },
};
</script>
<style scoped>
.kktin {
    text-align: justify;
}
</style>
